//@ts-ignore
export const gTag = window.gtag ?? {};
